import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  Modal,
  ModalBody,
  Input,
  Row,
  Col,
  FormGroup,
  Form,
  Button,
  Label,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { editUser, getUser } from "../../pages/users/services/user-service";
import { NAME_MAXLENGTH } from "../../constants/constants";
const OtpModel = ({ show, onCloseClick }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const successMessage = useSelector((state) => state.user.successMessage);
  const userProfile = useSelector((state) => state.user.userProfile);
  const user = useSelector((state) => state.user.users);
  const otpLength = 6;
  // Validation schema
  const validationSchema = Yup.object().shape({
    otp: Yup.array()
      .of(Yup.string().matches(/^\d$/, "Must be a digit").required("Required"))
      .length(otpLength, `Must be exactly ${otpLength} digits`),
  });

  useEffect(() => {
    if (successMessage) {
      onCloseClick();
      if (user?.profile_updated_at) {
        localStorage.setItem("user", JSON.stringify(user));
        navigate("/dashboard");
      }
    }
  }, [successMessage, navigate]);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { otp: Array(otpLength).fill("") },
  });

  const handleOtp = async (formData) => {
    const phone_otp = parseInt(Object.values(formData.otp).join(""));
    const updatedData = { ...userProfile, phone_otp };
    dispatch(editUser({ id: userProfile?._id, data: updatedData }));
  };

  const renderOtpInputs = () => {
    return Array.from({ length: otpLength }, (_, index) => (
      <Col key={index} xs="2">
        <Controller
          name={`otp[${index}]`}
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              type="text"
              maxLength="1"
              className="text-center"
              onChange={(e) => {
                field.onChange(e);
                const nextSibling = document.querySelector(
                  `input[name='otp[${index + 1}]']`
                );
                if (nextSibling && e.target.value) {
                  nextSibling.focus();
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Backspace" && !field.value && index > 0) {
                  const previousSibling = document.querySelector(
                    `input[name='otp[${index - 1}]']`
                  );
                  if (previousSibling) {
                    previousSibling.focus();
                  }
                }
              }}
            />
          )}
        />
      </Col>
    ));
  };

  const handleModalClose = () => {
    reset();
    onCloseClick();
  };

  return (
    <Modal size="md" isOpen={show} toggle={handleModalClose} centered={true}>
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button
            type="button"
            className="btn-close position-absolute end-0 top-0 m-3"
            onClick={handleModalClose}
          ></button>
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="mdi mdi-shield-check-outline"></i>
            </div>
          </div>
          <p className="text-muted font-size-16 mb-4">Verify Otp</p>
          <Form onSubmit={handleSubmit(handleOtp)}>
            <FormGroup className="text-start">
              <Label for="Name">Phone Number</Label>
              <Controller
                name="short_name"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <div>
                    <Input
                      {...field}
                      placeholder="Enter Phone nNumber"
                      // value={country?.name??""}
                      readOnly
                      maxLength={NAME_MAXLENGTH}
                    />
                  </div>
                )}
              />
            </FormGroup>
            <FormGroup>
              <Row>{renderOtpInputs()}</Row>
              {errors.otp && (
                <div className="text-danger mt-2">
                  {errors.otp.message || "All fields must be filled correctly"}
                </div>
              )}
            </FormGroup>
            <div className="hstack gap-2 justify-content-center mb-0">
              <Button type="submit" color="success">
                Verify OTP
              </Button>
              <Button
                type="button"
                color="secondary"
                onClick={handleModalClose}
              >
                Close
              </Button>
            </div>
          </Form>
        </ModalBody>
      </div>
    </Modal>
  );
};

OtpModel.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
};

export default OtpModel;

// import PropTypes from "prop-types";
// import React, { useEffect } from "react";
// import { useForm, Controller } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as Yup from "yup";
// import {
//   Modal,
//   ModalBody,
//   Input,
//   Row,
//   Col,
//   FormGroup,
//   Form,
//   Button,
// } from "reactstrap";
// import { editUser } from "../../pages/users/services/user-service";
// import { useDispatch, useSelector } from "react-redux";
// import { toast, ToastContainer } from "react-toastify";
// import { useNavigate } from "react-router-dom";

// const OtpModel = ({ show, onCloseClick }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const successMessage = useSelector((state) => state.user.successMessage);
//   const userProfile = useSelector((state) => state.user.userProfile);

//   const otpLength = 6;

//   // Validation schema
//   const validationSchema = Yup.object().shape({
//     otp: Yup.array()
//       .of(Yup.string().matches(/^\d$/, "Must be a digit").required("Required"))
//       .length(otpLength, `Must be exactly ${otpLength} digits`),
//   });

//   // useEffect(() => {
//   //   if (successMessage !== null) {
//   //     toast.success(successMessage);
//   //     // navigate("/dashboard");
//   //   }
//   // }, [successMessage, navigate]);

//   const {
//     handleSubmit,
//     control,
//     reset,
//     formState: { errors, isSubmitted },
//   } = useForm({
//     resolver: yupResolver(validationSchema),
//     defaultValues: { otp: Array(otpLength).fill("") },
//   });

//   const handleOtp = async (formData) => {
//     const phone_otp = parseInt(Object.values(formData.otp).join(""));
//     const updatedData = { ...userProfile, phone_otp };
//      console.log(updatedData,"phone")
//     // dispatch(editUser({ id: userProfile?._id, data: updatedData }));
//     // Add your OTP verification logic here
//   };

//   const renderOtpInputs = () => {
//     return Array.from({ length: otpLength }, (_, index) => (
//       <Col key={index} xs="2">
//         <Controller
//           name={`otp[${index}]`}
//           control={control}
//           render={({ field }) => (
//             <Input
//               {...field}
//               type="text"
//               maxLength="1"
//               className="text-center"
//               onChange={(e) => {
//                 field.onChange(e);
//                 const nextSibling = document.querySelector(
//                   `input[name='otp[${index + 1}]']`
//                 );
//                 if (nextSibling && e.target.value) {
//                   nextSibling.focus();
//                 }
//               }}
//               onKeyDown={(e) => {
//                 if (e.key === "Backspace" && !field.value && index > 0) {
//                   const previousSibling = document.querySelector(
//                     `input[name='otp[${index - 1}]']`
//                   );
//                   if (previousSibling) {
//                     previousSibling.focus();
//                   }
//                 }
//               }}
//             />
//           )}
//         />
//       </Col>
//     ));
//   };

//   const handleModalClose = () => {
//     reset();
//     onCloseClick();
//   };

//   return (
//     <>
//       <ToastContainer autoClose={2000} />
//       <Modal size="md" isOpen={show} toggle={handleModalClose} centered={true}>
//         <div className="modal-content">
//           <ModalBody className="px-4 py-5 text-center">
//             <button
//               type="button"
//               className="btn-close position-absolute end-0 top-0 m-3"
//               onClick={handleModalClose}
//             ></button>
//             <div className="avatar-sm mb-4 mx-auto">
//               <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
//                 <i className="mdi mdi-shield-check-outline"></i>
//               </div>
//             </div>
//             <p className="text-muted font-size-16 mb-4">Verify Otp</p>
//             <Form onSubmit={handleSubmit(handleOtp)}>
//               <FormGroup>
//                 <Row>{renderOtpInputs()}</Row>
//                 {isSubmitted && errors.otp && (
//                   <div className="text-danger mt-2">
//                     {errors.otp.message ||
//                       "All fields must be filled correctly"}
//                   </div>
//                 )}
//               </FormGroup>
//               <div className="hstack gap-2 justify-content-center mb-0">
//                 <Button type="submit" color="success">
//                   Verify OTP
//                 </Button>
//                 <Button
//                   type="button"
//                   color="secondary"
//                   onClick={handleModalClose}
//                 >
//                   Close
//                 </Button>
//               </div>
//             </Form>
//           </ModalBody>
//         </div>
//       </Modal>
//     </>
//   );
// };

// OtpModel.propTypes = {
//   onCloseClick: PropTypes.func.isRequired,
//   show: PropTypes.bool.isRequired,

//   onOtpClick: PropTypes.func.isRequired,
// };

// export default OtpModel;
